module.exports = __webpack_public_path__ + "static/media/vari2.38e16064.png";